<template>
    <div>
      <Navbar />
      <Header/>
      <Content/>
      <Footer/>
    </div>
  </template>
  
  <script>
  import Navbar from '@/components/Navbar.vue'
  import Header from '@/components/PrivacyPolicy/Header.vue';
  import Content from '@/components/PrivacyPolicy/Content.vue';
  import Footer from '@/components/Footer.vue';
  export default {
    name: 'PrivacyPolicy',
    components: {
      Navbar,
      Header,
      Content,
      Footer
    }
  }
  </script>
  
  <style scoped>
  
  </style>